import Modal from 'shared/components/modals/Modal';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';

const Header = ({caption, mode, translate}) => {
  if (!caption) return null;

  return (
    <div className={`h3 medium mb1 ${mode === 'danger' ? 'scarlet' : ''}`}>
      {translate ? <FormattedMessage id={caption}/> : caption}
    </div>
  );
};

const SubHeader = ({caption, translate}) => {
  if (!caption) return null;

  return (
    <div className='h2 medium mb2'>
      {translate ? <FormattedMessage id={caption}/> : caption}
    </div>
  );
};

const Body = ({text, translate}) => {
  if (!text) return null;

  return (
    <div className='h4 mb3 jumbo'>
      {translate ? <FormattedMessage id={text}/> : text}
    </div>
  );
};

const AlertModal = observer(({onHide, isOpen, header, subHeader, body, size = 'md', mode, children, translate = true}) => {
  return (
    <Modal onHide={onHide} size={size} isOpen={isOpen}>
      <Header caption={header} mode={mode} translate={translate}/>
      <SubHeader caption={subHeader} translate={translate}/>
      <Body text={body} translate={translate} />
      {children}
    </Modal>
  );
});

export default AlertModal;
